<template>
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Connect to Wallet</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <ul>
                        <li><a href="#">Metamask <img src="../assets/images/metamask.png" alt=""></a></li>
                        <li><a href="#">WalletConnect <img src="../assets/images/portis.png" alt=""></a></li>
                        <li><a href="#">Coinbase Wallet <img src="../assets/images/fortmatic.png" alt=""></a></li>
                        <li><a href="#">Fortmatic <img src="../assets/images/fortmatic.png" alt=""></a></li>
                        <li><a href="#">Portis <img src="../assets/images/portis.png" alt=""></a></li>
                        <li><a href="#">Torus <img src="../assets/images/metamask.png" alt=""></a></li>
                    </ul>
                </div>
                <div class="modal-footer">
                    <p>New to Ethereum? <a href="#">Learn more about wallets</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConnectPopup'
}
</script>

<style scoped>

</style>
